import {createRouter, createWebHistory} from 'vue-router';
import HomeView from '../views/LoginView.vue';
import {useUserStore} from "@/stores/user.js";
import {URLS_FACTORY} from "./urls.js";

const routes = [
	{
		path: URLS_FACTORY.URLS_PATHS.ROOT,
		name: 'home',
		meta: {requiresGuest: true},
		component: HomeView
	},
	{
		path: URLS_FACTORY.URLS_PATHS.FORGOT_PASSWORD,
		name: 'forgotpassword',
		meta: {requiresGuest: true},
		// route level code-splitting
		// this generates a separate chunk (About.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import('@/views/ForgotPasswordView.vue')
	},
	{
		path: URLS_FACTORY.URLS_PATHS.DASHBOARD,
		// only authenticated users can create posts
    meta: {requiresAuth: true, breadcrumbLabelKey: 'home'},
		component: () => import('@/views/dashboard/DashboardView.vue'),
		children: [
			{
				path: URLS_FACTORY.URLS_PATHS.HOME,
        alias: '',
				name: 'dashboard_home',
        component: () => import('@/views/dashboard/HomeView.vue')
			},
			{
				path: URLS_FACTORY.URLS_PATHS.USERS,
				name: 'users',
        meta: {breadcrumbLabelKey: 'users'},
        children: [ //usiamo questa forma per gestire il breadcrumb
          {
            path: '',
            name: 'users_list',
            component: () => import('@/views/dashboard/UsersView.vue'),
          },
          {
            path: ':id',
            name: 'user',
            meta: {breadcrumbLabelKey: 'new_user', breadcrumbFromStore: true},
            props: true,
            component: () => import('@/views/dashboard/UserView.vue')
          }
        ]
			},
      {
        path: URLS_FACTORY.URLS_PATHS.GROUPS,
        name: 'groups',
        meta: {breadcrumbLabelKey: 'groups'},
        children: [ //usiamo questa forma per gestire il breadcrumb
          {
            path: '',
            name: 'groups_list',
            component: () => import('@/views/dashboard/GroupsView.vue'),
          },
          {
            path: ':id',
            name: 'group',
            meta: {breadcrumbLabelKey: 'new_group', breadcrumbFromStore: true},
            props: true,
            component: () => import('@/views/dashboard/GroupView.vue')
          }
        ]
      },
      {
        path: URLS_FACTORY.URLS_PATHS.CUSTOMERS,
        name: 'customers',
        meta: {breadcrumbLabelKey: 'customers'},
        children: [ //usiamo questa forma per gestire il breadcrumb
          {
            path: '',
            name: 'customers_list',
            component: () => import('@/views/dashboard/CustomersView.vue'),
          },
          {
            path: ':id',
            name: 'customer',
            meta: {breadcrumbLabelKey: 'new_customer', breadcrumbFromStore: true},
            props: true,
            component: () => import('@/views/dashboard/CustomerView.vue')
          }
        ]
      },
      {
        path: URLS_FACTORY.URLS_PATHS.ORDERS,
        name: 'orders',
        meta: {breadcrumbLabelKey: 'orders'},
        children: [ //usiamo questa forma per gestire il breadcrumb
          {
            path: '',
            name: 'orders_list',
            component: () => import('@/views/dashboard/OrdersView.vue'),
          },
          {
            path: ':id',
            name: 'order',
            meta: {breadcrumbLabelKey: 'new_order', breadcrumbFromStore: true},
            props: true,
            component: () => import('@/views/dashboard/OrderView.vue')
          },
          {
            path: ':id/stats',
            name: 'order_stats',
            meta: {breadcrumbLabelKey: 'order_stats', breadcrumbFromStore: true},
            props: true,
            component: () => import('@/views/dashboard/OrderStatsView.vue')
          }
        ]
      },
      {
        path: URLS_FACTORY.URLS_PATHS.UPLOAD_TYPES,
        name: 'upload_types',
        meta: {breadcrumbLabelKey: 'upload_types'},
        children: [ //usiamo questa forma per gestire il breadcrumb
          {
            path: '',
            name: 'upload_types_list',
            component: () => import('@/views/dashboard/UploadTypesView.vue'),
          },
          {
            path: ':id',
            name: 'upload_type',
            meta: {breadcrumbLabelKey: 'new_upload_type', breadcrumbFromStore: true},
            props: true,
            component: () => import('@/views/dashboard/UploadTypeView.vue')
          }
        ]
      },
      {
        path: URLS_FACTORY.URLS_PATHS.ORDER_TYPES,
        name: 'order_types',
        meta: {breadcrumbLabelKey: 'order_types'},
        children: [ //usiamo questa forma per gestire il breadcrumb
          {
            path: '',
            name: 'order_types_list',
            component: () => import('@/views/dashboard/OrderTypesView.vue'),
          },
          {
            path: ':id',
            name: 'order_type',
            meta: {breadcrumbLabelKey: 'new_order_type', breadcrumbFromStore: true},
            props: true,
            component: () => import('@/views/dashboard/OrderTypeView.vue')
          }
        ]
      },
      {
        path: URLS_FACTORY.URLS_PATHS.PROFILE,
        name: 'profile',
        component: () => import('@/views/dashboard/ProfileView.vue')
      },
    ]
	},
	// everything else will match everything and put it under `$route.params.pathMatch` (we don't use a specific 404 page, but we redirect to homepage)
	{path: '/:pathMatch(.*)*', name: 'NotFound', component: () => import('../views/404View.vue')}
];

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	scrollBehavior(to, from, savedPosition){
		// more info https://router.vuejs.org/guide/advanced/scroll-behavior.html
		if(to.hash){
			return {el: to.hash, behavior: 'smooth'}
		}
		// always scroll to top
		return {top: 0}
	},
	//NOTA: se aggiungi una pagina pubblica, ricordati di aggiungerne il path in pages.js così che vada in sitemap!
	routes: routes
});

router.beforeEach((to, from) => {
	const userStore = useUserStore();
	// instead of having to check every route record with
	// to.matched.some(record => record.meta.requiresAuth)
	if(to.meta.requiresAuth && !userStore.isLoggedIn){
		// this route requires auth, check if logged in
		// if not, redirect to login page.
		return {
			path: URLS_FACTORY.URLS_PATHS.ROOT,
			// save the location we were at to come back later
			query: {redirect: to.fullPath}
		};
	}
	if(to.meta.requiresGuest && userStore.isLoggedIn){
		// this route requires not auth, check if logged in
		// if yes, redirect to home page.
		return {
			path: URLS_FACTORY.getURL(URLS_FACTORY.URLS_FULL_PATHS.FULL_DASHBOARD)
		};
	}
});

export default router;
